import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import type { Me } from '@vuokramani/shared';
import { api, ApiError } from './api.ts';

export const meQueryKey = ['me'] as const;

/** Kirjautunut käyttäjä, tai null jos ei kirjautunut. */
export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: async () => {
      try {
        return await api<Me>('/auth/me');
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 60_000,
  });
}

/** Etusivu roolin mukaan. */
export function homePath(me: Me): string {
  if (me.roles.landlord) return '/vuokranantaja';
  if (me.roles.tenant) return '/vuokralainen';
  if (me.isAdmin) return '/admin';
  return '/vuokranantaja';
}

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: () => api<void>('/auth/logout', { method: 'POST' }),
    onSettled: () => {
      queryClient.clear();
      void navigate('/kirjaudu', { replace: true });
    },
  });
}

export function initials(me: Pick<Me, 'name' | 'email'>): string {
  const source = me.name?.trim() || me.email;
  const parts = source.split(/[\s@.]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (me.name ? (parts[1]?.[0] ?? '') : '')).toUpperCase();
}
